<template>
  <div
    class="pagoda-form-collapse"
    :style="{
      height: collapse ? visibleHeight : 'auto'
    }"
  >
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'FormCollapse',
    props: {
      collapse: Boolean,
      lines: {
        type: Number,
        default: 1
      }
    },
    computed: {
      visibleHeight () {
        return `${this.rowHeight * this.lines}px`
      }
    },
    watch: {
      collapse () {
        this.$pagoda.$emit('form-table-layout:dolayout')
      }
    },
    data () {
      return {
        rowHeight: 0
      }
    },
    mounted () {
      this.getRowHeight()
    },
    methods: {
      getRowHeight () {
        const formItem = this.$el.querySelector('.el-form-item')

        if (formItem) {
          const formItemStyle = getComputedStyle(formItem)
          const formItemHeight = parseInt(formItemStyle.marginTop) + formItem.clientHeight + parseInt(formItemStyle.marginBottom)

          this.rowHeight = formItemHeight
        }
      }
    }
  }
</script>